//@flow
import React from "react"
import { Switch, Route } from "react-router-dom"
import SensorListView from "./SensorListView"
import SensorFormView from "./SensorFormView"
import queries from "./queries"

import type { Match } from "react-router-dom"
import type { SensorListQuery } from "./types"

const Sensors = ({ match }: { match: Match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/:id`} component={SensorFormView} />
      <Route component={SensorListView} />
    </Switch>
  )
}

export { queries }

export type { SensorListQuery }

export default Sensors



// WEBPACK FOOTER //
// ./src/Sensors/index.js